<div class="avatar-group avatar-group-{{size}}">
  <sc-avatar *ngFor="let user of users | slice:0:itemsToShow; let i = index;" [user]="user" [size]="size" [class.ms-0]="i == 0"></sc-avatar>
  <span class="avatar avatar-{{size}}" *ngIf="users.length - itemsToShow > 0">
    <span class="avatar-title rounded-circle border border-white">+{{users.length - itemsToShow}}</span>
  </span>
</div>
